import React from 'react';
import styled from '@emotion/styled';
import TableContext from './TableContext';

const Component = styled.tbody``;

const table = {
  variant: 'body',
};

const TableBody: React.FunctionComponent = (props) => {
  return (
    <TableContext.Provider value={table}>
      <Component {...props} />
    </TableContext.Provider>
  );
};

export default TableBody;
